<script lang="ts" setup>
import { Primitive, type PrimitiveProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'
import { RouterLink } from 'vue-router'

import { cn } from '@/utils'

const props = withDefaults(defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>(), {
  as: RouterLink,
  class: '',
  asChild: false,
})
</script>

<template>
  <Primitive :as="as" :as-child="asChild" :class="cn('hover:text-foreground transition-colors', props.class)">
    <slot />
  </Primitive>
</template>
